import Script from 'next/script';
import type { ReactNode } from 'react';

/*
    This is a virtual import, i.e. `uno.css` will never be present anywhere on the disk. It is handled by the `UnoCSS` webpack plugin
    setup in `next.config.mjs`. This plugin creates a `<style>` section with all the extracted styles in the html in development, and
    creates a hashed css file in production.
 */
import 'uno.css';

import '../components/style.css';

// TODO move this to shared and replace it other places
declare global {
    interface Window {
        TrackJS?: {
            install: (data: { token: string; application: string; version: string; enabled: boolean }) => void;
        };
    }
}

const SeoApp = ({ Component, pageProps }): ReactNode => (
    <>
        <Component {...pageProps} />
        <Script
            src="https://cdn.trackjs.com/agent/v3/latest/t.js"
            onLoad={() => {
                window.TrackJS?.install?.({
                    token: '74bb3e28a1604fd2b28c72c568722d21',
                    application: 'finn-travel-seo',
                    version: `'${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}'`,
                    enabled: location.host.indexOf('local') !== 0 && location.host.indexOf('127.0.0') !== 0,
                });
            }}
            crossOrigin=""
        />
    </>
);

export default SeoApp;
